<template>
  <div>
    <div
      v-for="(question, questionIndex) in response.content.data"
      :key="questionIndex"
    >
      <div class="flex justify-between flex-nowrap pb-2 border-base-30 border-b p-4">
        <div>
          <div class="quiz__type">
            {{ $i18nPresenter.t('Pick Answer') }}
          </div>
          <p class="font-bold" :class="{'text-base': isModalContent}">
            {{ question.questionTitle }}
          </p>
        </div>
        <div class="flex-shrink-0 pl-7">
          <aha-button
            @click="handleAddSlideToPresentation(response)"
            :submitting="response.isAddingSlide"
            :disabled="response.isDisabled || response.isAddingSlide"
          >
            {{ $i18nPresenter.t('Add') }}
          </aha-button>
        </div>
      </div>
      <ul class="quiz-item-options">
        <li
          v-for="(options, optIndex) in question.slideOptions"
          :key="optIndex"
          class="quiz-item-option"
          :class="{
            'marked': options.correct
          }"
        >
          {{ options.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
    isModalContent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAddSlideToPresentation(response) {
      this.$emit('handleAddSlideToPresentation', response)
    },
  },
}
</script>

<style lang="scss">
.quiz__type {
  background-color: #EFF1F7; // secondary-15
  width: max-content;
  font-size: 12px;
  border-radius: 20px;
  padding: 0 0.5rem;
  color: #3F4557; // secondary-60
  margin-bottom: 0.5rem;
}

.quiz-item-options {
  display: block;
  list-style-type: upper-alpha;
  padding: 0 1rem 1rem 1rem;
}

.quiz-item-option {
  position: relative;
  padding: 1rem 2.25rem 1rem 0;
  list-style-type: upper-alpha;
  list-style-position: inside;

  &:not(:first-child) {
    border-top: 1px solid #ebebeb;
  }

  &::marker {
    font-weight: 700;
  }

  &::after {
    visibility: hidden;
    position: absolute;
    top: 1rem;
    right: 0;
    color: #D3D7E1;
    font-family: 'Font Awesome 5 Free';
    content: '\f058';
    font-weight: 900;
    font-size: 1rem;
  }

  &.marked::after {
    visibility: visible;
  }
}
</style>
